import { render, staticRenderFns } from "./Term.vue?vue&type=template&id=5e1a3842&scoped=true"
import script from "./Term.vue?vue&type=script&lang=js"
export * from "./Term.vue?vue&type=script&lang=js"
import style0 from "./Term.vue?vue&type=style&index=0&id=5e1a3842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1a3842",
  null
  
)

export default component.exports